import React, { FC } from 'react'

import { IconClappingProps } from './IconClapping.types'
import * as Styled from './styles/IconClapping.style'

import { nonThemeableRules } from '../../ruleSet'

const IconClapping: FC<IconClappingProps> = ({
  size = nonThemeableRules.defaultSize as number as IconClappingProps['size'],
  isResponsive = false,
}: IconClappingProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m20.121 21.637-2.324-1.907c-.875-.718-2.117-.66-2.766.13l-.078.093c-.644.797-.453 2.02.41 2.735l2.387 1.957m7.672 6.315-7.672-6.304c-.871-.718-2.113-.66-2.75.13l-.078.093c-.645.785-.461 2.02.414 2.734l3.164 2.614'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='m22.984 33.926-4.5-3.7a1.928 1.928 0 0 0-2.718.25l-.075.094c-.648.785-.464 2.02.41 2.735l4.426 3.636s7.141 6.043 11.313 6.137c3.023.07 4.926-.95 6.61-3 .882-1.074 3.179-3.27 1.84-8.25-2.419-9-3.395-13.066-3.395-13.066s-2.594-.078-2.692 3.015c-.047 1.75.899 4.727 0 5.051-.473.172-1.367-.062-3.887-1.816-.816-.567-7.75-6.356-7.75-6.356-.875-.715-2.117-.66-2.765.133l-.074.09c-.653.797-.477 2.031.402 2.746l7.707 6.328'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path
          d='m14.61 31.21-4.551-2.5c-.985-.546-1.383-1.726-.883-2.624l.058-.102v-.015c.532-.922 1.672-1.367 2.594-.832l2.777 1.437-4.75-2.46c-.984-.548-1.382-1.735-.882-2.626l.058-.105c.5-.895 1.801-1.192 2.785-.637'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M15.3 22.613 9.06 19.25c-.985-.547-1.383-1.73-.883-2.621l.058-.106c.5-.894 1.715-1.171 2.7-.62l6.41 3.538-3.797-2.07c-1-.547-1.383-1.73-.883-2.625l.055-.101c.5-.895 1.715-1.172 2.703-.622 0 0 7.848 4.48 8.75 4.899 2.789 1.281 3.707 1.351 4.144 1.105.84-.476-.62-3.25-.875-4.976C27 12 29.56 11.609 29.56 11.609s2.82 5.625 4.656 9.868'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path
          d='M16.934 9.813V5.559m6.043 6.277 3.207-3.207m-5.914 1.605 2.656-6.558'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconClapping
